import { NgModule } from '@angular/core';
import { GraphTileModule } from '@ndt/report-output/shared/graphs/graph-tile/graph-tile.module';
import { TileDirectivesModule } from './directives/tile-directives.module';
import { FallbackTileModule } from './fallback-tile/fallback-tile.module';
import { TileViewModule } from './tile-view/tile-view.module';

@NgModule({
   imports: [TileDirectivesModule, FallbackTileModule, TileViewModule, GraphTileModule],
   exports: [TileDirectivesModule, FallbackTileModule, TileViewModule, GraphTileModule],
})
export class SharedTileModule {}
